import * as React from 'react'
import { TaskCell } from './TaskCell'
import { useFormatTime } from '~/hooks/useFormatTime'

function TableHeader({ column }) {
  return <div className="font-roboto">{column.id}</div>
}

export function useColumns() {
  const formatTime = useFormatTime()

  return [
    {
      accessorKey: 'Candidate',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => {
        const url = props.row.original.candidate_url
        const name = props.row.original.candidate
        return url ? <a href={url}>{name}</a> : name
      },
    },
    {
      accessorKey: 'Program Level',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.candidate_program_level,
    },
    {
      accessorKey: 'Coach Service',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => props.row.original.service_request,
    },
    {
      accessorKey: 'Task',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => <TaskCell {...props} />,
    },
    {
      accessorKey: 'Created',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => formatTime(props.row.original.created_at, 'short'),
    },
    {
      accessorKey: 'Due Date',
      header: (props) => <TableHeader {...props} />,
      cell: (props) => {
        if (!props.row.original.due_at) return 'N/A'
        return formatTime(props.row.original.due_at, 'short')
      },
    },
  ]
}
